import * as CART_ENDPOINTS from "../constants/endpoints/cart";
import axios from "../axios/axios";

export const getCart = () => {
  return axios({
    url: CART_ENDPOINTS.GET_CART,
    method: "GET",
  });
};

export const increaseSkuQuantity = (
  skuId,
  currentQuantity,
  price,
  increaseBy
) => {
  return axios({
    url: CART_ENDPOINTS.INCREASE_SKU_QUANTITY,
    method: "POST",
    data: {
      skuId,
      currentQuantity,
      price,
      increaseBy,
    },
  });
};

export const decreaseSkuQuantity = (
  skuId,
  currentQuantity,
  price,
  decreaseBy
) => {
  return axios({
    url: CART_ENDPOINTS.DECREASE_SKU_QUANTITY,
    method: "POST",
    data: {
      skuId,
      currentQuantity,
      price,
      decreaseBy,
    },
  });
};

export const increaseBundleQuantity = (
  bundleId,
  currentQuantity,
  increaseBy
) => {
  return axios({
    url: CART_ENDPOINTS.INCREASE_BUNDLE_QUANTITY,
    method: "POST",
    data: {
      bundleId,
      currentQuantity,
      increaseBy,
    },
  });
};

export const decreaseBundleQuantity = (
  bundleId,
  currentQuantity,
  decreaseBy
) => {
  return axios({
    url: CART_ENDPOINTS.DECREASE_BUNDLE_QUANTITY,
    method: "POST",
    data: {
      bundleId,
      currentQuantity,
      decreaseBy,
    },
  });
};

export const acceptSkuPrice = (skuId, price) => {
  return axios({
    url: CART_ENDPOINTS.ACCEPT_SKU_PRICE,
    method: "POST",
    data: { skuId, price },
  });
};

export const deleteSku = (skuId) => {
  return axios({
    url: CART_ENDPOINTS.DELETE_SKU,
    method: "POST",
    data: {
      skuId,
    },
  });
};
